import constants from '../constants';

export const setRoutes = routes => ({
  type: constants.SET_ROUTES,
  payload: routes,
});

export const changeRoute = path => ({
  type: constants.CHANGE_ROUTE,
  payload: path,
});
